import { styled } from '@mui/material/styles';
import { Card, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';

export const CardStyled = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
}));

export const CardHeaderStyled = styled(CardHeader)({
  padding: '16px',
});

export const CardContentStyled = styled(CardContent)({
  padding: '16px !important',
  paddingTop: '0 !important',
});
